import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './i18n';
import { SnackbarProvider } from 'notistack';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { isAuthenticated, logout } from './services/Auth';
import * as serviceWorker from './serviceWorker';

const notistackRef = React.createRef<any>();
const onClickDismiss = (key: any) => {
    notistackRef.current.closeSnackbar(key);
}

window.onstorage = (e) => {
    if (e.key === 'auth-user' && e.oldValue !== e.newValue){
        window.location.reload();
    }
};

window.onfocus = (e: any) => {
    if (isAuthenticated() === false && window.location.pathname !== "/Sign") {
        logout();
    }
}

ReactDOM.render(
    <Suspense fallback="">
        <SnackbarProvider
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            autoHideDuration={5000}
            ref={notistackRef}
            action={(key) => (
                <IconButton size="small" aria-label="close" color="inherit" onClick={() => onClickDismiss(key)}>
                    <CloseIcon fontSize="small" />
                </IconButton>
            )}
        >
            <App />
        </SnackbarProvider>
    </Suspense>,
    document.getElementById('root'),
);
serviceWorker.unregister();
